const Language = {
	en: {
		language: "Language",
		time: "Time",
		before: "Before 10 AM",
		after: "After 5 PM",
		children: "See children",
		other: "Other",
	},
	es: {
		language: "Idioma",
		time: "Horario",
		before: "Antes de las 10 AM",
		after: "Después de las 5 PM",
		children: "Ver niños",
		other: "Otro",
	},
	ko: {
		language: "Lang",
		time: "Orè",
		before: "Anvan 10 AM",
		after: "Apre 5 PM",
		children: "Gade timoun yo",
		other: "Lòt",
	}
};
export default Language;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-advance-filter-options/doctor-advance-filter-options.language.js